<template>
  <main class="follow-page">
    <section class="hero">
      <img src="./static/images/follow-hero.png" alt="科技主视觉">
    </section>

    <section class="qr-panel">
    
      <img
        v-show="qrcodeUrl"
        class="qr"
        :src="qrcodeUrl || './static/images/follow-qr.png'"
      
        @load="handleQrcodeLoaded"
        @error="handleQrcodeLoaded"
      >
      <p>长按关注公众号</p>
    </section>
  </main>
</template>

<script>
export default {
  name: "followNew",
  data () {
    return {
      qrcodeUrl: "",
      iccid: "",
      isQrcodeLoading: true,
      loadingStartAt: 0
    }
  },
  methods: {
    stopQrcodeLoading () {
      const elapsed = Date.now() - this.loadingStartAt
      const delay = Math.max(0, 500 - elapsed)
      setTimeout(() => {
        this.isQrcodeLoading = false
      }, delay)
    },
    handleQrcodeLoaded () {
      this.stopQrcodeLoading()
    },
    getOperatorQrcode () {
      if (!this.iccid) {
        this.stopQrcodeLoading()
        return
      }
      this.$toast.loading({
        message: "加载中",
        duration: 0,
        forbidClick: true
      })
      this.fetchData("/card/cardOperator", { iccid: this.iccid }, (res) => {
        this.$toast.clear()
        if (res && res.code && res.data && res.data.qrcode) {
          this.qrcodeUrl = res.data.qrcode
        } else {
          this.stopQrcodeLoading()
        }
      })
    }
  },
  created () {
    this.loadingStartAt = Date.now()
    this.iccid = this.$route.query.iccid || sessionStorage.getItem("iccid") || ""
    this.getOperatorQrcode()
  }
}
</script>

<style scoped src="./static/css/follow.css"></style>
<style scoped>
.qr-loading {
  position: absolute;
  width: 1.63rem;
  height: 1.61rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
  border-radius: 0.08rem;
  z-index: 2;
}

.qr-loading-spinner {
  width: 0.28rem;
  height: 0.28rem;
  border: 0.03rem solid #d9ecff;
  border-top-color: #1989fa;
  border-radius: 50%;
  animation: follow-spin .8s linear infinite;
}

@keyframes follow-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/newpage/follow.vue